var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
var useStyles = makeStyles(function (theme) {
  return {
    hr: _extends({
      display: 'flex',
      color: theme.palette.getContrastText(R.path(['palette', 'tertiary', 'main'], theme) || theme.palette.common.black),
      alignItems: 'center',
      textAlign: 'center',
      '&::before, &::after': {
        content: 'close-quote',
        flex: 1,
        borderTop: '.0625em solid',
        margin: '0.5em'
      }
    }, R.pathOr({}, ['mixins', 'labelDivider', 'root'], theme)),
    margin: {
      marginTop: theme.spacing(1.25),
      marginBottom: theme.spacing(1.25)
    }
  };
});
export var LabelDivider = function LabelDivider(_ref) {
  var _cx;
  var label = _ref.label,
    color = _ref.color,
    withMargin = _ref.withMargin;
  var classes = useStyles();
  return React.createElement(Typography, {
    className: cx(classes.hr, (_cx = {}, _cx[classes.margin] = withMargin, _cx)),
    style: {
      color: color
    }
  }, label);
};
LabelDivider.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  color: PropTypes.string,
  withMargin: PropTypes.bool
} : {};
export default LabelDivider;